/* eslint-disable max-len */

import { actionStruct } from '../utils';

const Types = {
  SET_PERMISSIONS: 'SET_PERMISSIONS'
};

const INITIAL_VALUE = [];

export const setPermissions = (permissions) => actionStruct(Types.SET_PERMISSIONS, { permissions });

export const reducer = (state = INITIAL_VALUE, action) => {
  const { type, payload } = action;
  switch (type) {
    case Types.SET_PERMISSIONS:
      return payload.permissions;

    default:
      return state;
  }
};
